import { useCallback, useMemo, useRef } from "react";
import messages from "./translations/messages";
import createTranslator from "../../../util/translationHelper";
import { useAppStateProvider } from "../../../contextProviders/AppStateProvider";
import { SUBSCRIPTION_STATUS } from "../../../container/QBO_Accounting/constants";

function useHeader(props) {
  const { lang } = props;
  const BLOCK = useRef("header");
  const { appState, updateAppStateLocal } = useAppStateProvider();

  const translate = useMemo(() => {
    return createTranslator(messages);
  }, [createTranslator, messages]);

  const connectLink = appState?.qboSubscription?.status === SUBSCRIPTION_STATUS.PENDING
    ? `/${lang}/qbo-accounting/terms`
    : `/${lang}/qbo-accounting/pricing`;
  const connectedLink = "https://qbo.intuit.com";

  const eligibility = appState?.qboConnectionEligibility;
  const eligibilityError = appState?.qboEligibilityError || false;
  const eligibilityLoading = appState?.qboEligibilityLoading || false;
  const shouldBlockConnect =
    eligibilityError ||
    eligibility === "multiple_mids" ||
    eligibility === "mid_already_connected" ||
    eligibility === "no_mids_assigned";

  const handleConnectClick = useCallback(
    (e) => {
      if (eligibilityError) {
        e.preventDefault();
        return;
      }
      if (shouldBlockConnect) {
        e.preventDefault();
        updateAppStateLocal({ eligibilityModalOpen: true });
      }
    },
    [shouldBlockConnect, eligibilityError, updateAppStateLocal],
  );

  const handleAccountSettings = useCallback(() => {
    updateAppStateLocal({
      accountSettingsSidebarOpen: true,
      disconnectedStatusModal: false,
      disconnectErrorStatusModal: false,
    });
  }, [updateAppStateLocal]);

  return {
    BLOCK,
    translate,
    connectLink,
    connectedLink,
    handleAccountSettings,
    handleConnectClick,
    eligibilityError,
    eligibilityLoading,
  };
}

const Hook = {
  useHeader,
};

export default Hook;

